import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import template from './NewInstallationGroup.rt';
import * as nigActions from './NewInstallationGroupActions';
import * as actions from '../../../actions'
import _ from 'lodash';
import * as editorNames from '../../../constants/editorNames';

const STEPS = {
  VIEW: 0,
  FORM: 1
}

export const InstallationIcons = [
  'arch.svg','backsplash.svg','brackets.svg','bump-out.svg','cabinets.svg','countertop-removal.svg',
  'cutouts.svg','dishwasher-strip.svg','edge-profile.svg','fabrication.svg','faucets.svg','finishes.svg','flooring.svg','hourly-labor.svg',
  'inside-corner.svg','installation.svg','microwave.svg','milling-down.svg','outlet-cutout.svg','oversized-handling-fee.svg','plumbing.svg',
  'radius.svg','range-hood.svg','range-top-cutout.svg','range.svg','refrigerator.svg','room.svg','sealer.svg','sinks.svg',
  'stove-type.svg','template.svg','topmount-sink-cutout.svg','trip-charge.svg','undermount-sink-cutout.svg'
]

function mapStateToProps(state, props) {
  return {

  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onUpdateTransientField: (groupName, key, value) => {
      dispatch(actions.updateTransientFieldForCustomEditor(editorNames.INSTALLATION_GROUP, {name: groupName}, key, value));
    },
    addPendingInstallationGroup: (name, image, desc) => dispatch(nigActions.addNewInstallationGroup(name, desc, image))
  };
}

class _NewInstallationGroup extends PureComponent {
  state = {
    groupName: "",
    groupDescription: "",
    image: null,
    step: STEPS.VIEW,
    selectingIcon: false,
    alerts: []
  }

  updateValue = (key, value) => {
    let alerts = this.state.alerts;
    if(_.trim(value).length > 0) {
      var al = alerts.indexOf(key);
      if(al >= 0) {
        alerts.splice(al, 1);
      }
    }
    this.setState({alerts, [key]: value});
  }

  setStep = (step) => {
    this.setState({step});
  }

  getIconOptions = () => {
    return InstallationIcons;
  }

  getSelectedIconStyle = () => {
    if(this.state.image) {
      return {
        backgroundImage: "url('/content/views/dashboard/images/icons/pj-scope-icons/enabled/" + this.state.image + "')",
        backgroundSize: "contain"
      }; 
    }
    return {};
  }

  onSave = () => {
    let alerts = [];
    if(_.trim(this.state.groupName).length == 0) {
      alerts.push("groupName");
    } 
    if(_.trim(this.state.image).length == 0) {
      alerts.push("image");
    }
    if(_.trim(this.state.groupDescription).length == 0) {
      alerts.push("groupDescription");
    }

    if(alerts.length == 0) {
      this.props.onUpdateTransientField(this.state.groupName, "name", this.state.groupName);
      this.props.onUpdateTransientField(this.state.groupName, "image", this.state.image);
      this.props.onUpdateTransientField(this.state.groupName, "description", this.state.groupDescription);
      this.props.addPendingInstallationGroup(this.state.groupName, this.state.image, this.state.groupDescription);
      this.onCancel();
    } else {
      this.setState({alerts});
    }
  }

  onCancel = () => {
    this.setState({
      groupName: "",
      groupDescription: "",
      image: null,
      step: STEPS.VIEW,
      selectingIcon: false,
      alerts: []
    });
  }

  render = template
}

const NewInstallationGroup = connect(mapStateToProps, mapDispatchToProps)(_NewInstallationGroup);

export default NewInstallationGroup;
export { NewInstallationGroup };
